<template>
  <div class="video-player">
    <video
      crossorigin="*"
      preload="metadata"
      ref="videoplayer"
      playsinline
      @click.prevent="toggleVideo"
    >
      <source :src="dataVideo.urlVideo" type="video/mp4" />
    </video>

    <div class="progress" v-if="dataEnter">
      <div class="progress__line" :style="{ transform: `scaleX(${progress})`}"></div>
    </div>

    <div class="pause"
      v-show="dataEnter"
      data-mouse
      data-mouse-attractionState="active"
      data-mouse-attractionVal="10"
      data-mouse-magnetism="2"
      data-hover-type="fadeout"
      @click="pausedVideo"
    >
      <span class="pause__item"></span>
      <span class="pause__item"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Videoplayer',

  props: ['stopVideo', 'playVideo', 'dataVideo', 'dataEnter'],

  data() {
    return {
      isPaused: { type: Boolean, default: true },
      options: { type: Object, required: true },
      currentTime: 0,
      durationVideo: 0,
    };
  },

  computed: {
    progress() {
      const progress = Math.round(this.currentTime) / Math.round(this.durationVideo);
      return progress;
    },
  },

  mounted() {
    this.$refs.videoplayer.addEventListener('loadedmetadata', () => {
      this.durationVideo = this.$refs.videoplayer.duration;
    });

    this.$refs.videoplayer.addEventListener('timeupdate', () => {
      this.currentTime = this.$refs.videoplayer.currentTime;

      if (this.currentTime === this.durationVideo) {
        this.isPaused = true;

        this.stopVideo();
        this.$refs.videoplayer.currentTime = 0;
      }
    });
  },

  methods: {
    pausedVideo() {
      this.isPaused = true;

      this.stopVideo();
      this.$refs.videoplayer.pause();
    },

    toggleVideo() {
      if (this.isPaused) {
        this.isPaused = false;

        this.playVideo();
        this.$refs.videoplayer.play();
      } else {
        this.isPaused = true;

        this.stopVideo();
        this.$refs.videoplayer.pause();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/mixins';
@import '../styles/colors';

.video-player {
  position: relative;
  width: 100%;

  background-color: transparent;

  @include aspect-ratio(16, 9);

  overflow: hidden;

  video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }

  .progress {
    position: absolute;
    bottom: 20px;
    left: 50px;
    width: calc(100% - 150px);
    height: 2px;
    background-color: $color-dark-gray;

    &__line {
      position: relative;
      width: 100%;
      height: 2px;
      background-color: $color-blue;

      transform: scaleX(0);
      transform-origin: 0 0;
      transition: all 2.5s cubic-bezier(0.215, 0.61, 0.355, 1);
    }
  }

  .pause {
    position: absolute;
    bottom: 0;
    right: 40px;
    width: 41px;
    height: 45px;
    padding: 14px;

    display: flex;
    justify-content: space-between;
    align-items: center;

    &__item {
      display: inline-block;
      position: relative;
      width: 4px;
      height: 17px;

      border: 1px solid $color-dark-gray;
      transition: all 0.3s cubic-bezier(.17,.67,.32,.87);
    }

    &:hover > span {
      border: 1px solid transparent;
      background-color: $color-blue;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Videoplayer.vue